import { render, staticRenderFns } from "./FrsMap.vue?vue&type=template&id=2194cb60&lang=html&"
import script from "./FrsMap.vue?vue&type=script&lang=js&"
export * from "./FrsMap.vue?vue&type=script&lang=js&"
import style0 from "./FrsMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports